export default function useCommonQuickStartViewState() {
  throw new Error('Not implemented on this platform');
}
